import React, { useState, useEffect } from "react";
import MainApp from "./components/MainApp";
import AuthModal from "./components/AuthModal";
import { User, LoginResponse } from "./types";
import { getItem, removeItem } from "./utils/localStorage";
import { Toaster, toast } from "sonner";
import { logout } from "./api/auth";
import { useTranslation } from "react-i18next";

function App() {
  const { t, i18n } = useTranslation();
  const [user, setUser] = useState<LoginResponse | null>(null);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState<
    "login" | "register" | "forgotPassword"
  >("login");

  useEffect(() => {
    const storedUser = getItem<LoginResponse>("user");
    if (storedUser) {
      setUser(storedUser);
    }
  }, []);

  const handleLogin = (userData: LoginResponse) => {
    setUser(userData);
    // setItem('user', userData);
    setShowAuthModal(false);
    toast.success(t("auth.loginSuccess"));
  };

  const handleLogout = async () => {
    const result = await logout();

    if (result.error) {
      toast.error(`${result.error.message}`);
    } else {
      window.location.href = "/";
      setUser(null);
      console.log("logout successful:", result.data);
    }
  };

  const openAuthModal = (mode: "login" | "register" | "forgotPassword") => {
    setAuthMode(mode);
    setShowAuthModal(true);
  };

  const closeAuthModal = () => {
    setShowAuthModal(false);
  };

  return (
    <>
      <MainApp user={user} onLogout={handleLogout} onOpenAuth={openAuthModal} />

      {showAuthModal && (
        <AuthModal
          mode={authMode}
          onLogin={handleLogin}
          onClose={closeAuthModal}
          onSwitchMode={(mode) => setAuthMode(mode)}
        />
      )}
      <Toaster richColors />
    </>
  );
}

export default App;
